/* Warranty claim form — logic for the <warranty-claim-form> custom element.
   Markup: sections/warranty-form.liquid  Styles: assets/warranty-form.css
   Config via data attributes: data-max-photos, data-api-base. */

(function () {
  'use strict';
  if (customElements.get('warranty-claim-form')) return;

  class WarrantyClaimForm extends HTMLElement {
    connectedCallback() {
      var root = this;
      if (root.dataset.wfInit) return;
      root.dataset.wfInit = '1';

      var form = root.querySelector('[data-wf-form]');
        var steps = Array.prototype.slice.call(root.querySelectorAll('[data-wf-step]'));
        var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wf-tab]'));
        var counter = root.querySelector('[data-wf-step-counter]');
        var alertBox = root.querySelector('[data-wf-alert]');
        var reviewBox = root.querySelector('[data-wf-review]');
        var thankyou = root.querySelector('[data-wf-thankyou]');
        var card = root.querySelector('.wf-card');
        var tabsList = root.querySelector('.wf-tabs');
        var photoInput = root.querySelector('[data-wf-photos]');
        var previews = root.querySelector('[data-wf-previews]');
        var photoError = root.querySelector('[data-wf-photo-error]');
        var dropzone = root.querySelector('[data-wf-dropzone]');
        var MAX_PHOTOS = parseInt(root.dataset.maxPhotos || '6', 10);
        var API_BASE = root.dataset.apiBase || '/apps/klim-api/warranty';
        var TOTAL_STEPS = 5;
        var MAX_BYTES = 10 * 1024 * 1024;
        var current = 1;
        var maxVisited = 1;
        var photoFiles = [];

        /* Purchase date can't be in the future */
        var dateInput = form.querySelector('[name="purchaseDate"]');
        if (dateInput) dateInput.max = new Date().toISOString().split('T')[0];

        /* ---------- Prefill from the customer-account "Start a warranty claim" link ---------- */
        (function () {
          var params = new URLSearchParams(window.location.search);
          if (!params.get('orderId') && !params.get('variantId')) return;

          function setVal(name, value) {
            var el = form.querySelector('[name="' + name + '"]');
            if (el && value && !el.value) el.value = value;
          }

          var styleBits = [params.get('productTitle'), params.get('color')].filter(Boolean).join(' / ');
          setVal('productStyleColor', styleBits || params.get('sku'));
          setVal('productSize', params.get('size'));
          var pd = params.get('purchaseDate');
          if (pd && /^\d{4}-\d{2}-\d{2}$/.test(pd)) setVal('purchaseDate', pd);

          /* Ride-along identifiers for the RESTlet payload (hidden inputs; survive form.reset) */
          ['orderId', 'lineItemId', 'variantId', 'orderName'].forEach(function (key) {
            var value = params.get(key);
            if (!value) return;
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            input.defaultValue = value;
            form.appendChild(input);
          });

          /* "Starting a claim for…" note at the top of the card */
          var bits = [];
          if (params.get('orderName')) bits.push('order ' + params.get('orderName'));
          if (styleBits) bits.push(styleBits + (params.get('size') ? ' / ' + params.get('size') : ''));
          if (bits.length) {
            var note = document.createElement('p');
            note.className = 'wf-help';
            note.style.margin = '0 0 14px';
            note.textContent = 'Starting a claim for ' + bits.join(' — ');
            var body = root.querySelector('.wf-card__body');
            body.insertBefore(note, body.firstChild);
          }
        })();

        function stepEl(n) {
          return steps.filter(function (s) { return s.getAttribute('data-wf-step') === String(n); })[0];
        }

        function showStep(n) {
          current = n;
          maxVisited = Math.max(maxVisited, n);
          steps.forEach(function (s) { s.hidden = s.getAttribute('data-wf-step') !== String(n); });
          tabs.forEach(function (t) {
            var tn = parseInt(t.getAttribute('data-wf-tab'), 10);
            t.classList.toggle('is-active', tn === n);
            t.classList.toggle('is-visited', tn <= maxVisited && tn !== n);
            t.setAttribute('aria-selected', tn === n ? 'true' : 'false');
          });
          if (counter) counter.textContent = 'Step ' + n + ' of ' + TOTAL_STEPS;
          hideAlert();
          updatePhysicalOption();
          if (n === TOTAL_STEPS) buildReview();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        /* Location-dependent behaviour, re-run whenever the Location changes:
           - Physical evaluation is only offered for US locations: hide the
             checkbox (and clear it) when the selected Location isn't "US".
           - State/Province is not required when "Non-US" is selected.
           Matches on the option label so API-driven ID changes can't break it. */
        function updatePhysicalOption() {
          var locationSelect = form.querySelector('[name="locationId"]');
          var physicalField = root.querySelector('[data-wf-physical-option]');
          if (!locationSelect) return;
          var opt = locationSelect.options[locationSelect.selectedIndex];
          var optText = opt ? opt.text.trim().toUpperCase() : '';
          var isUS = optText === 'US';
          var isNonUS = optText.indexOf('NON') === 0;

          if (physicalField) {
            physicalField.hidden = !isUS;
            if (!isUS) {
              var cb = physicalField.querySelector('[name="evalPhysical"]');
              if (cb) cb.checked = false;
            }
          }

          var stateInput = form.querySelector('[name="stateProvince"]');
          if (stateInput) {
            if (isNonUS) {
              stateInput.removeAttribute('data-wf-required');
              clearFieldError(stateInput);
            } else {
              stateInput.setAttribute('data-wf-required', '');
            }
            var stateReq = root.querySelector('label[for="' + stateInput.id + '"] .wf-req');
            if (stateReq) stateReq.hidden = isNonUS;
          }
        }

        function showAlert(msg) {
          alertBox.textContent = msg;
          alertBox.hidden = false;
        }
        function hideAlert() { alertBox.hidden = true; }

        function setFieldError(input, msg) {
          var field = input.closest('.wf-field');
          if (!field) return;
          field.classList.add('has-error');
          var err = field.querySelector('.wf-error');
          if (err) { err.textContent = msg; err.hidden = false; }
        }
        function clearFieldError(input) {
          var field = input.closest('.wf-field');
          if (!field) return;
          field.classList.remove('has-error');
          var err = field.querySelector('.wf-error');
          if (err) err.hidden = true;
        }

        function validateStep(n) {
          var container = stepEl(n);
          if (!container) return true;
          var ok = true;
          var firstMsg = '';
          var required = container.querySelectorAll('[data-wf-required]');
          Array.prototype.forEach.call(required, function (input) {
            clearFieldError(input);
            var value = (input.value || '').trim();
            var msg = input.getAttribute('data-wf-msg') || 'This field is required';
            var bad;
            if (input.type === 'checkbox') {
              bad = !input.checked;
            } else {
              bad = !value;
            }
            if (!bad && input.type === 'email') {
              bad = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            }
            if (bad) {
              setFieldError(input, msg);
              if (!firstMsg) firstMsg = msg;
              ok = false;
            }
          });

          /* Email confirmation match */
          if (ok && n === 2) {
            var email = form.querySelector('[name="email"]');
            var confirm = form.querySelector('[name="confirmEmail"]');
            if (email && confirm && email.value.trim().toLowerCase() !== confirm.value.trim().toLowerCase()) {
              setFieldError(confirm, 'Email addresses do not match');
              firstMsg = 'Email addresses do not match';
              ok = false;
            }
          }

          /* At least one evaluation option (Physical / Photo) must be selected.
             Physical is US-only, so for non-US locations Photo is effectively required. */
          if (ok && n === 4) {
            var physical = form.querySelector('[name="evalPhysical"]');
            var photo = form.querySelector('[name="evalPhoto"]');
            var physicalOption = root.querySelector('[data-wf-physical-option]');
            var physicalVisible = physical && physicalOption && !physicalOption.hidden;
            var anyChecked = (physicalVisible && physical.checked) || (photo && photo.checked);
            if (!anyChecked) {
              firstMsg = physicalVisible
                ? 'Please select an evaluation option (Physical or Photo)'
                : 'Please select the Photo evaluation option';
              ok = false;
            }
          }

          if (!ok) {
            showAlert(firstMsg);
            var firstBad = container.querySelector('.wf-field.has-error input, .wf-field.has-error select, .wf-field.has-error textarea');
            if (firstBad) firstBad.focus();
          }
          return ok;
        }

        /* ---------- Photos ---------- */
        var ACCEPT = ['image/jpeg', 'image/png', 'image/gif'];

        function renderPreviews() {
          previews.innerHTML = '';
          photoFiles.forEach(function (file, i) {
            var wrap = document.createElement('div');
            wrap.className = 'wf-preview';
            var img = document.createElement('img');
            img.alt = file.name;
            var reader = new FileReader();
            reader.onload = function (e) { img.src = e.target.result; };
            reader.readAsDataURL(file);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.setAttribute('aria-label', 'Remove ' + file.name);
            btn.textContent = '×';
            btn.addEventListener('click', function () {
              photoFiles.splice(i, 1);
              renderPreviews();
            });
            wrap.appendChild(img);
            wrap.appendChild(btn);
            previews.appendChild(wrap);
          });
        }

        function addPhotos(fileList) {
          photoError.hidden = true;
          var rejected = [];
          Array.prototype.forEach.call(fileList, function (file) {
            if (photoFiles.length >= MAX_PHOTOS) { rejected.push(file.name + ' (limit of ' + MAX_PHOTOS + ' photos)'); return; }
            if (ACCEPT.indexOf(file.type) === -1) { rejected.push(file.name + ' (only .jpeg/.jpg/.png/.gif allowed)'); return; }
            if (file.size > MAX_BYTES) { rejected.push(file.name + ' (larger than 10 MB)'); return; }
            photoFiles.push(file);
          });
          if (rejected.length) {
            photoError.textContent = 'Not added: ' + rejected.join(', ');
            photoError.hidden = false;
          }
          renderPreviews();
        }

        if (photoInput) {
          photoInput.addEventListener('change', function () {
            addPhotos(photoInput.files);
            photoInput.value = '';
          });
        }
        if (dropzone) {
          ['dragenter', 'dragover'].forEach(function (evt) {
            dropzone.addEventListener(evt, function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
          });
          ['dragleave', 'drop'].forEach(function (evt) {
            dropzone.addEventListener(evt, function (e) { e.preventDefault(); dropzone.classList.remove('is-dragover'); });
          });
          dropzone.addEventListener('drop', function (e) {
            if (e.dataTransfer && e.dataTransfer.files) addPhotos(e.dataTransfer.files);
          });
        }

        /* ---------- Review ---------- */
        function fieldLabel(name) {
          var el = form.querySelector('[name="' + name + '"]');
          if (!el) return name;
          var field = el.closest('.wf-field, .wf-check');
          var label = field && field.querySelector('label, .wf-label');
          return label ? label.textContent.replace('*', '').trim() : name;
        }

        function displayValue(name) {
          var el = form.querySelector('[name="' + name + '"]');
          if (!el) return '';
          if (el.type === 'checkbox') return el.checked ? 'Yes' : 'No';
          if (el.tagName === 'SELECT') {
            var opt = el.options[el.selectedIndex];
            return opt ? opt.text : '';
          }
          return el.value;
        }

        var REVIEW_GROUPS = [
          { title: 'Contact Information', step: 2, fields: ['locationId', 'submitterName', 'customerName', 'email', 'phoneNumber', 'streetAddress', 'city', 'stateProvince', 'postalCode', 'countryId'] },
          { title: 'Product Identification', step: 3, fields: ['productTypeId', 'productStyleColor', 'productSize', 'poNumber', 'purchaseDate'] },
          { title: 'Type of Claim', step: 4, fields: ['warrantyClaim', 'repairQuote', 'itemActivityId', 'incomingMessage', 'briefDescription', 'evalPhysical', 'evalPhoto', 'additionalWarranties'] }
        ];

        var REVIEW_LABELS = {
          locationId: 'Location', submitterName: 'Name', customerName: 'Customer Name',
          email: 'Email Address', phoneNumber: 'Phone Number', streetAddress: 'Return Shipping Address', city: 'City',
          stateProvince: 'State/Province', postalCode: 'Postal Code', countryId: 'Country',
          productTypeId: 'Product Type', productStyleColor: 'Product Style / Color', productSize: 'Product Size',
          poNumber: 'PO Number', purchaseDate: 'Purchase Date',
          warrantyClaim: 'Warranty', repairQuote: 'Repair Quote', itemActivityId: 'Activity',
          incomingMessage: 'Description of Issue', briefDescription: 'Additional Comments',
          evalPhysical: 'Physical Evaluation', evalPhoto: 'Photo Evaluation',
          additionalWarranties: 'Additional Warranties'
        };

        function buildReview() {
          reviewBox.innerHTML = '';
          REVIEW_GROUPS.forEach(function (group) {
            var wrap = document.createElement('div');
            wrap.className = 'wf-review-group';
            var h = document.createElement('h4');
            h.textContent = group.title;
            var edit = document.createElement('button');
            edit.type = 'button';
            edit.className = 'wf-review-edit';
            edit.textContent = 'Edit';
            edit.addEventListener('click', function () { showStep(group.step); });
            var table = document.createElement('table');
            table.className = 'wf-review-table';
            group.fields.forEach(function (name) {
              var val = displayValue(name);
              if (!val) return;
              var tr = document.createElement('tr');
              var td1 = document.createElement('td');
              td1.textContent = REVIEW_LABELS[name] || fieldLabel(name);
              var td2 = document.createElement('td');
              td2.textContent = val;
              tr.appendChild(td1);
              tr.appendChild(td2);
              table.appendChild(tr);
            });
            wrap.appendChild(h);
            wrap.appendChild(edit);
            wrap.appendChild(table);
            reviewBox.appendChild(wrap);
          });
          if (photoFiles.length) {
            var p = document.createElement('p');
            p.style.fontSize = '.92em';
            p.innerHTML = '<strong>Photos attached:</strong> ' + photoFiles.length;
            reviewBox.appendChild(p);
          }
        }

        /* ---------- Navigation ---------- */
        root.addEventListener('click', function (e) {
          if (e.target.closest('[data-wf-next]')) {
            if (validateStep(current)) showStep(current + 1);
          } else if (e.target.closest('[data-wf-back]')) {
            showStep(current - 1);
          } else {
            var tab = e.target.closest('[data-wf-tab]');
            if (tab) {
              var n = parseInt(tab.getAttribute('data-wf-tab'), 10);
              if (n <= maxVisited && n !== current) {
                /* Only move forward through validation */
                if (n < current || validateStep(current)) showStep(n);
              }
            }
          }
        });

        /* Clear field errors as the user types */
        form.addEventListener('input', function (e) {
          if (e.target.matches('[data-wf-required]')) clearFieldError(e.target);
          if (e.target.matches('[data-wf-charcount]')) updateCharCount(e.target);
        });

        /* Live "N of MAX characters" counter for maxlength-capped fields
           (shows once the user is within 60 characters of the cap) */
        function updateCharCount(field) {
          var counter = root.querySelector('[data-wf-charcount-for="' + field.id + '"]');
          var max = parseInt(field.getAttribute('maxlength') || '0', 10);
          if (!counter || !max) return;
          var used = field.value.length;
          /* show within 10% of the cap (min 60 chars) */
          var show = used >= max - Math.max(60, Math.round(max * 0.1));
          counter.hidden = !show;
          if (show) counter.textContent = used + ' of ' + max + ' characters';
        }

        /* Re-evaluate the US-only Physical option whenever Location changes,
           and keep Physical / Photo mutually exclusive — one or the other. */
        form.addEventListener('change', function (e) {
          if (e.target.matches('[name="locationId"]')) updatePhysicalOption();
          if (e.target.matches('[name="evalPhysical"]') && e.target.checked) {
            var photo = form.querySelector('[name="evalPhoto"]');
            if (photo) photo.checked = false;
          }
          if (e.target.matches('[name="evalPhoto"]') && e.target.checked) {
            var physical = form.querySelector('[name="evalPhysical"]');
            if (physical) physical.checked = false;
          }
        });

        /* ---------- Populate dropdowns from the warranty API (app proxy) ---------- */
        (function () {
          /* locationId is intentionally NOT populated from the API: the form
             shows only US / Non-US (see the section markup + "Non-US location
             ID" setting), while the API list still has US/Europe/International. */
          var MAP = [
            { name: 'productTypeId',  keys: ['productTypes', 'product_types', 'producttypes'] },
            { name: 'itemActivityId', keys: ['activities', 'itemActivities', 'activity'] },
            { name: 'countryId',      keys: ['countries', 'country'] }
          ];
          /* Backend currently serves /form-values (older path); the proxy API doc
             says /form-options — try the live one first, fall back to the doc's. */
          fetch(API_BASE + '/form-values', { method: 'POST' })
            .then(function (r) {
              if (r.ok) return r.json();
              return fetch(API_BASE + '/form-options', { method: 'POST' })
                .then(function (r2) { return r2.ok ? r2.json() : null; });
            })
            .then(function (json) {
              var lists = json && json.success && json.data && json.data.lists;
              if (!lists) return;
              MAP.forEach(function (m) {
                var list = null;
                for (var i = 0; i < m.keys.length; i++) {
                  if (Array.isArray(lists[m.keys[i]]) && lists[m.keys[i]].length) { list = lists[m.keys[i]]; break; }
                }
                var select = form.querySelector('select[name="' + m.name + '"]');
                if (!list || !select) return;
                var current = select.value;
                select.innerHTML = '<option value=""></option>';
                list.forEach(function (item) {
                  var opt = document.createElement('option');
                  opt.value = (item && item.id != null) ? item.id : ((item && item.value != null) ? item.value : item);
                  opt.textContent = (item && (item.name || item.text || item.label)) || String(opt.value);
                  select.appendChild(opt);
                });
                if (current) select.value = current;
              });
            })
            .catch(function () { /* backend not reachable — keep the built-in fallback options */ });
        })();

        /* ---------- Submit → POST {API_BASE}/case via the Shopify app proxy ---------- */
        var submitting = false;
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (submitting) return;
          for (var s = 1; s <= 4; s++) {
            if (!validateStep(s)) { showStep(s); return; }
          }

          var submitBtn = form.querySelector('[data-wf-submit]');
          var btnText = submitBtn.querySelector('.btn__text') || submitBtn;
          var originalText = btnText.textContent;
          submitting = true;
          submitBtn.disabled = true;
          btnText.textContent = 'Submitting…';
          hideAlert();

          /* Multipart form post (per backend): scalar fields + images[] file parts.
             Checkboxes and the Yes/No selects go as '1'/'0'; unanswered selects are omitted. */
          var BOOL_SELECTS = { warrantyClaim: true, repairQuote: true };

          var fd = new FormData();
          Array.prototype.forEach.call(form.querySelectorAll('input[name], select[name], textarea[name]'), function (el) {
            if (el.type === 'file') return;
            if (el.type === 'checkbox') { fd.append(el.name, el.checked ? '1' : '0'); return; }
            if (BOOL_SELECTS[el.name]) {
              if (el.value === 'Yes') fd.append(el.name, '1');
              else if (el.value === 'No') fd.append(el.name, '0');
              return;
            }
            fd.append(el.name, el.value.trim());
          });
          photoFiles.forEach(function (file) { fd.append('images[]', file, file.name); });

          fetch(API_BASE + '/case', {
            method: 'POST',
            body: fd
          }).then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (json) {
              return { ok: res.ok, json: json };
            });
          }).then(function (result) {
            if (!result.ok || !result.json || result.json.success !== true) {
              var msg = (result.json && result.json.message) || 'Something went wrong submitting your claim. Please try again.';
              showAlert(msg);
              alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            /* Prefer the customer-facing case number once the API returns it;
               data.caseId is the NetSuite internal ID and only a fallback. */
            var data = result.json.data || {};
            var caseId = data.caseNumber || data.casenumber || data.caseId;
            var caseEl = thankyou.querySelector('[data-wf-case-number]');
            if (caseEl) {
              caseEl.hidden = !caseId;
              if (caseId) caseEl.textContent = 'Case #' + caseId;
            }
            card.hidden = true;
            tabsList.hidden = true;
            thankyou.hidden = false;
            /* Hide the page heading on the thank-you view */
            var titleEl = root.querySelector('[data-wf-title]');
            if (titleEl) titleEl.hidden = true;
            thankyou.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }).catch(function (err) {
            console.error('[warranty-form] submit failed:', err);
            showAlert('Something went wrong submitting your claim. Please try again.');
          }).then(function () {
            submitting = false;
            submitBtn.disabled = false;
            btnText.textContent = originalText;
          });
        });

        /* Reset for a new case */
        root.addEventListener('click', function (e) {
          if (!e.target.closest('[data-wf-reset]')) return;
          form.reset();
          photoFiles = [];
          renderPreviews();
          maxVisited = 1;
          var caseEl = thankyou.querySelector('[data-wf-case-number]');
          if (caseEl) caseEl.hidden = true;
          thankyou.hidden = true;
          card.hidden = false;
          tabsList.hidden = false;
          /* Show the page heading again */
          var titleEl = root.querySelector('[data-wf-title]');
          if (titleEl) titleEl.hidden = false;
          showStep(1);
        });
    }
  }

  customElements.define('warranty-claim-form', WarrantyClaimForm);
})();
